export interface ValidatorError {
  key: string;
  options?: {
    [index: string]: any;
  };
  requiredError?: boolean;
  level?: TipLevels;
}

export enum TipLevels {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  TIP = 'TIP'
}

export type ValidatorResult = ValidatorError | false;

export type Validator = (...args: any[]) => ValidatorResult;

export interface Dictionary {
  [name: string]: any;
}

export interface Constraints {
  [field: string]: Validator[];
}

export interface ValidationResult {
  [field: string]: ValidatorError;
}
